import type { ReactNode, HTMLAttributes } from 'react';

type CardPadding = 'none' | 'sm' | 'md' | 'lg';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  shadow?: boolean;
  border?: boolean;
  interactive?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

const paddingClasses: Record<CardPadding, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-5',
  lg: 'p-6',
};

export function Card({
  padding = 'md',
  shadow = false,
  border = true,
  interactive = false,
  header,
  footer,
  children,
  className = '',
  ...props
}: CardProps) {
  return (
    <div
      className={[
        'bg-white rounded-lg',
        border ? 'border border-surface-200' : '',
        shadow ? 'shadow-sm' : '',
        interactive ? 'hover:shadow-md hover:border-surface-300 transition-shadow cursor-pointer' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    >
      {header && (
        <div className="px-5 py-4 border-b border-surface-200">
          {header}
        </div>
      )}
      <div className={paddingClasses[padding]}>{children}</div>
      {footer && (
        <div className="px-5 py-3 border-t border-surface-200 bg-surface-50 rounded-b-lg">
          {footer}
        </div>
      )}
    </div>
  );
}
